import * as React from 'react';
import { ConfigurationModel, TroughModel } from 'franke-trough-dependencies';
import { GlobalPrivateState, QueryParemeterPayload, ActiveFilterValue, checkIfTroughIsActive } from 'src/api';
import TroughAdd from '../TroughAdd/TroughAdd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import closeThin from '../../../../assets/images/icons/close-thin.svg';
import infoCircle from '../../../../assets/images/icons/info-circle.svg';

import './TroughListLargeItem.scss';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { RequestApiResult, IsAuthentificatedState } from 'loopback-react-request';
import classNames from 'classnames';
import TroughImage from '../TroughImage/TroughImage';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './TroughListLargeItem.messages';
import { Button } from 'reactstrap';

export interface TroughListLargeItemProps {
  activeFilters?: ActiveFilterValue[];
  disable: boolean;
  params: QueryParemeterPayload;
  trough: TroughModel;
  troughId: string;
  authenticator: IsAuthentificatedState;
}

export interface TroughListLargeItemState {
  selected: boolean;
  redirect: boolean;
}

export class TroughListLargeItemPartial extends React.Component<TroughListLargeItemProps, TroughListLargeItemState> {
  constructor(props: TroughListLargeItemProps) {
    super(props);
    this.state = {
      selected: false,
      redirect: false
    };
  }

  public render() {
    const { trough } = this.props;

    const unavailableTroughs = ['TROUGHKEYSHERE'];
    
    return (
      <div 
        className={classNames(
          'partial-trough-list-item-large',
          'col-12 col-md-6 col-lg-6 col-xl-4', {
            'active': this.active,
          }, {
            'selected': this.state.selected,
          }
        )}
      >
        {this.state.redirect && (
          <Redirect to="/configuration/new" />
        )}
        <div className="trough-list-item-inner">
          <div className="trough-image">
            <img src={`https://kwcws3d.blob.core.windows.net/cdn/images/troughs/${trough.fileName}.png`} className="img-fluid" alt={trough.name} />
          </div>

          <div className="trough-content">
            <div className="trough-heading pt-1 pb-3">
              <div className="row">
                <div className="col-10 text-left d-flex">
                  <h6>{trough.name}</h6>
                  {/*unavailableTroughs.includes(trough.sapName) && (
                    <span className="warning"><FormattedMessage {...MESSAGES.troughListItemUnavailable} /></span>
                  )*/}
                </div>
                <div className="col-2 text-right">
                  <i onClick={this.handleClickInfo} style={{cursor: 'pointer'}}>
                    {this.state.selected ? (
                      <img 
                        className="img-fluid" 
                        src={closeThin}
                        alt="close"
                        style={{height: 28, padding: 7}}
                      />
                    ) : (
                      <img 
                        className="img-fluid" 
                        src={infoCircle}
                        alt="info"
                        style={{height: 28}}
                      />
                    )}
                  </i>
                </div>
              </div>
            </div>
            <div className="trough-data">
              <div className="row">
                <div className="col-6 text-left">
                  <h6><FormattedMessage {...MESSAGES.troughListItemTrough} /></h6>
                  <table>
                    <tbody>
                      <tr>
                        <td><FormattedMessage {...MESSAGES.troughListItemWidth} /></td>
                        <td>{trough.throughWidth} mm</td>
                      </tr>
                      <tr>
                        <td><FormattedMessage {...MESSAGES.troughListItemHeight} /></td>
                        <td>{trough.throughHeight} mm</td>
                      </tr>
                      <tr>
                        <td><FormattedMessage {...MESSAGES.troughListItemDepth} /></td>
                        <td>{trough.throughDepth} mm</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-6 text-left">
                  <h6><FormattedMessage {...MESSAGES.troughListItemMin} /></h6>
                  <table>
                    <tbody>
                      <tr>
                        <td><FormattedMessage {...MESSAGES.troughListItemWidth} /></td>
                        <td>{trough.minPlateWidth} mm</td>
                      </tr>
                      <tr>
                        <td><FormattedMessage {...MESSAGES.troughListItemDepth} /></td>
                        <td>{trough.plateDepth.min} mm</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="trough-ctas">
              <a className="btn border" href={`https://kwcws3d.blob.core.windows.net/cdn/technical-drawings/${trough.fileName}.pdf`} target="_blank"><FormattedMessage {...MESSAGES.troughPdf} /></a>
              <button className="btn border" onClick={this.handleClickStart}>
                {this.props.authenticator.isAuthentificated ? (
                  <FormattedMessage {...MESSAGES.troughStart} />
                ) : (
                  <FormattedMessage {...MESSAGES.troughStartWithLogin} />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleClickInfo = () => {
    this.setState({
      ...this.state,
      selected: !this.state.selected
    });
  }

  handleClickStart = () => {
    const { trough } = this.props;
    localStorage.setItem('startingTrough', trough.id);
    this.setState({
      ...this.state,
      redirect: true
    });
  }

  private get active(): boolean {
    const { activeFilters, trough } = this.props;
    if (!activeFilters) {
      return false;
    }
    return checkIfTroughIsActive(trough, activeFilters);
  }
}

export const TroughListLargeItem = connect((state: GlobalPrivateState) => ({
  params: state.queryState.params,
  authenticator: state.authenticator,
}))(TroughListLargeItemPartial);

export default TroughListLargeItem;
